import React, { useEffect, useState } from "react";
import { appInsights } from "../../../../config/appInsights";
import CustomInputField from "../../../CustomHTMLElements/CustomInputField";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useLocation, useRouteMatch } from "react-router-dom";
import {
  useCustomerAccountDetails,
  useIndividualCustomerDetails,
} from "../../../../custom-hooks/useIndividualCustomer";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import {
  CustomerData,
  CustomerDataDocument,
} from "../../../../interfaces/individualCustomer";
import ButtonLoader, { Loader } from "../../../../UI/Loaders/Loaders";
import { Document, Page, pdfjs } from "react-pdf";
// Required for pdfjs worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const IndividualKycDocumentsTabs = () => {
  const match = useRouteMatch();
  const { id } = match?.params as { id: string };

  const [modal, setModal] = useState(false);
  const [numPages, setNumPages] = useState<number | null>(null);

  const [document, setDocument] = useState<CustomerDataDocument | undefined>();
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  useEffect(() => {
    appInsights.trackPageView({
      name: "IndividualKycDocumentsTabs",
      isLoggedIn: true,
    });
  }, []);

  const {
    data: customerData,
    isLoading,
    isError,
  } = useIndividualCustomerDetails({
    customerId: Number(id),
  });

  const toggleModal = () => {
    setModal(!modal);
  };

  if (isLoading)
    return <Loader centered={true} text="Loading customer accounts..." />;

  if (isError)
    return (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> There was an issue while fetching
            customer accounts, Please Reload The Page{" "}
          </h4>
        </div>
      </div>
    );

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <br />
          <div>
            <CustomInputField
              label="BVN"
              type="text"
              name="bvn"
              disabled
              defaultValue={customerData?.data?.personalDetails?.bvn}
            />
          </div>
          <div className="mt-5">
            <CustomInputField
              label="NIN"
              type="text"
              name="nin"
              disabled
              defaultValue={
                customerData?.data?.personalDetails?.nin
                  ? String(customerData?.data?.personalDetails?.nin)
                  : "N/A"
              }
            />
          </div>
          <div>
            <label>Means of Identification</label>
            <div className="card">
              {customerData && customerData?.data?.documents?.length > 0 ? (
                customerData?.data?.documents?.map((item) => (
                  <div
                    key={item?.documentName}
                    className="card-body d-flex justify-content-between align-items-center"
                    style={{
                      padding: "10px 0",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <p
                      style={{ margin: "0" }}
                      className="advancly-primary-text"
                    >
                      {item?.documentName}
                      ................................................
                    </p>
                    <p
                      style={{ margin: "0" }}
                      className="cursor-pointer advancly-primary-text"
                      onClick={() => {
                        setDocument(item);
                        toggleModal();
                      }}
                    >
                      View
                    </p>
                  </div>
                ))
              ) : (
                <p className="d-flex justify-content-center align-items-center">
                  No documents uploaded
                </p>
              )}
            </div>
          </div>
        </div>

        <Modal
          isOpen={modal}
          toggle={toggleModal}
          size={
            document?.documentUrl?.endsWith("png") ||
            document?.documentUrl?.endsWith("jpg")
              ? ""
              : "xl"
          }
        >
          <ModalHeader toggle={toggleModal}>
            Identification document
          </ModalHeader>
          <ModalBody>
            <>
              {/* Image preview */}

              {(document?.documentUrl?.endsWith("png") ||
                document?.documentUrl?.endsWith("jpg")) && (
                <img
                  src={`https://advanclystorage.blob.core.windows.net/advancly/${document?.documentUrl}`}
                  alt="Drivers License"
                  className="img-fluid"
                />
              )}
              {/* PDF preview (react-pdf) */}
              {document?.documentUrl?.endsWith(".pdf") && (
                <div
                  style={{
                    overflow: "auto",
                  }}
                >
                  <Document
                    file={`https://advanclystorage.blob.core.windows.net/advancly/${document?.documentUrl}`}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<ButtonLoader />}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        width={900}
                      />
                    ))}
                  </Document>
                </div>
              )}
            </>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default IndividualKycDocumentsTabs;
